import { Clone, useGLTF } from "@react-three/drei";
import { useRoomStore } from "../../store";

function Door() {
  const { scene } = useGLTF("/models/door.glb");
  const scaleX = useRoomStore((s) => s.scaleX);
  const scaleZ = useRoomStore((s) => s.scaleZ);
  //   const height = useRoomStore((s) => s.height);
  return (
    <group
      userData={{
        link: "/",
        isDoor: true,
        hoverText: "Visit creator's profile",
      }}
      scale={25}
      position={[-scaleX * 0.3, 13, (scaleZ * 0.99) / 2]}
    >
      <Clone object={scene} />
    </group>
  );
}
export default Door;
